import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
export default function () {
  return Array.from(this);
}